var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8 2.4H6.4a4 4 0 0 0-4 4v3.2a4 4 0 0 0 4 4h3.2a4 4 0 0 0 4-4V8M14.4 1.6v3.2m0-3.2h-3.2m3.2 0L8 8","stroke":"var(--v-primary-base)","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }